// Cloudflare migration shim — replaces the former Supabase client.
// Form components still `import { supabase } from "@/integrations/supabase/client"`
// and call `supabase.functions.invoke(name, { body })`. Here that maps to a
// same-origin POST to the matching Cloudflare Pages Function under /api/*,
// returning the same `{ data, error }` shape the Supabase client did.

const FUNCTION_ROUTES: Record<string, string> = {
  "ghl-create-contact": "/api/ghl-create-contact",
};

type InvokeResult<T> = { data: T | null; error: { message: string } | null };

async function invoke<T = unknown>(
  name: string,
  options?: { body?: unknown }
): Promise<InvokeResult<T>> {
  const route = FUNCTION_ROUTES[name] ?? `/api/${name}`;
  try {
    const res = await fetch(route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(options?.body ?? {}),
    });
    const data = (await res.json().catch(() => null)) as T | null;
    if (!res.ok) {
      const message =
        (data && typeof data === "object" && "error" in data
          ? String((data as { error: unknown }).error)
          : null) ?? `Request failed (${res.status})`;
      return { data: null, error: { message } };
    }
    return { data, error: null };
  } catch (err) {
    return { data: null, error: { message: err instanceof Error ? err.message : "Network error" } };
  }
}

export const supabase = {
  functions: { invoke },
};
